import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Collapse } from '@mui/material';

import texts from '../texts.json';
import { Details } from '../styles';

/**
 * A failure message with the raw details behind a toggle, so a long server error does not
 * swamp the card but is still there to copy into a ticket.
 */
const ErrorDetails = ({ message, details }) => {
  const [isOpen, setIsOpen] = useState(false);
  const detailText = details.filter(Boolean).join('\n');

  return (
    <Alert
      severity="error"
      action={detailText && (
        <Button color="inherit" size="small" onClick={() => setIsOpen((open) => !open)}>
          {texts.item.details}
        </Button>
      )}
    >
      {message}
      {!!detailText && (
        <Collapse in={isOpen}>
          <Details>{detailText}</Details>
        </Collapse>
      )}
    </Alert>
  );
};

ErrorDetails.propTypes = {
  message: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(PropTypes.string),
};

ErrorDetails.defaultProps = {
  details: [],
};

export default ErrorDetails;
